import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@mezcal/ui/styles.css';

import '../styles/tailwind.css';

import { App } from './shell/App';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Missing root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
